// Data a prerendered route needs before its first render. The build (entry-prerender.jsx)
// awaits it before rendering and main.jsx awaits it before hydrating, so server HTML
// and the first client render match. Blog article bodies are code-split per post and
// would otherwise render as a skeleton on both sides.
const BLOG_POST_PATH = /^\/blog\/(?!page\/)([^/]+)\/?$/;

export async function preloadPrerenderedRoute(pathname) {
  const match = BLOG_POST_PATH.exec(pathname);
  if (!match) return;
  const { loadBlogPostContent } = await import("./constants/blogPosts");
  await loadBlogPostContent(decodeURIComponent(match[1]));
}
